<div class="container">
  <h1>
    <mat-icon>build</mat-icon>
    システムメンテナンス中
  </h1>

  <p>
    現在、システムのメンテナンスを実施しております。
    メンテナンス完了まで、システムをご利用いただくことができません。
  </p>

  <div class="instructions">
    <h2>メンテナンス中の対応について</h2>
    <ol>
      <li>
        <strong>自動復旧をお待ちください</strong>
        <p>メンテナンス完了後、自動的にシステムが利用可能になります。</p>
      </li>
      <li>
        <strong>ページの更新</strong>
        <p>
          メンテナンス完了後、下記ボタンでページを更新するか、しばらくお待ちください。
          ページは定期的に自動更新されます。
        </p>
      </li>
    </ol>
  </div>

  <div class="navigation">
    <button (click)="forceRefresh()" class="refresh-button">
      ページを更新
    </button>
  </div>

  <p class="footer">
    メンテナンスに関するお問い合わせは、サポートチームまでご連絡ください。
  </p>
</div>
